import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateProjectExpenseTypeRequestFailure() {
      return getState().isFailure;
    },
    isCreateProjectExpenseTypeRequestPending() {
      return getState().isPending;
    },
    isCreateProjectExpenseTypeRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
